<template>
    <div id="index" class="index">
        <!-- logo -->
        <div class="index-row">
            <div v-if="lang=='ja'" class="poetry animated bounceInLeft">
                <img :src="cdnPrefix+'/imgs/index-poetry.png'" alt="poetry" />
            </div>
            <div class="logo animated bounceInLeft">
                <img v-if="lang=='zh-CN'" :src="cdnPrefix+'/imgs/logo-cn.png'" />
                <img v-if="lang=='ja'" :src="cdnPrefix+'/imgs/logo.png'" />
                <img v-if="lang=='en'" :src="cdnPrefix+'/imgs/logo-en.png'" />
                <img v-if="lang=='th'" :src="cdnPrefix+'/imgs/logo-th.png'" />
            </div>
        </div>
        <!-- 中间横幅文字 -->
        <div class="index-row">
            <div class="slogan animated bounceInLeft">
                <img v-if="lang=='zh-CN'" :src="cdnPrefix+'/imgs/index-slogan-cn.png'" />
                <img v-if="lang=='ja'" :src="cdnPrefix+'/imgs/index-slogan-ja.png'" />
                <img v-if="lang=='en'" :src="cdnPrefix+'/imgs/index-slogan-en.png'" />
                <img v-if="lang=='th'" :src="cdnPrefix+'/imgs/index-slogan-th.png'" />
            </div>
        </div>
        <!-- 下载 -->
        <div class="index-row">
            <div class="channel animated bounceInLeft">
                <div class="text">{{$t("index.channel_text")}}</div>
                <div class="btn-down-group">
                    <a class="btn-down-appstore" href="https://apple.co/2VmsODZ">
                        <img :src="cdnPrefix+'/imgs/btn-down-appstore.png'" />
                    </a>
                    <a class="btn-down-google" href="http://bit.ly/2XtXsgL">
                        <img :src="cdnPrefix+'/imgs/btn-down-google.png'" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Index",
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            lang: window.localStorage.getItem("localeLanguage")
        };
    },
    components: {},
    created() {},
    mounted() {},
    methods: {
        download_appstore() {
            alert("appstore");
        },
        download_google() {
            alert("google");
        }
    }
};
</script>

<style lang="scss">
.hide {
    display: none;
}
.index {
    width: 100%;
    height: 100%;
    position: relative;
    padding-top: 70px;
    .index-row {
        width: 100%;
        display: flex;
        justify-content: center;
        .logo {
            width: 30%;
            margin-top: 100px;
        }
        .slogan {
            width: 60%;
            margin-top: 10px;
        }
        .channel {
            width: 50%;
            height: 160px;
            margin-top: 80px;
            background: url($cdnPrefix+"/imgs/index-channel.png") center center
                no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 0 5%;
            .text {
                width: 40%;
                height: 60px;
                line-height: 60px;
                font-size: 1.8rem;
                font-weight: bold;
                color: #441307;
                text-align: center;
            }
            .btn-down-group {
                height: 100%;
                width: 65%;
                display: flex;
                justify-content: space-around;
                a {
                    width: 40%;
                    display: flex;
                    align-items: center;
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .logo img,
        .poetry img,
        .slogan img,
        .channel img {
            width: 100%;
        }
        .poetry {
            position: absolute;
            left: 7%;
            top: 200px;
            width: 12%;
        }
    }
}
// 适配小屏
@media screen and (max-width: 1366px) {
    .index {
        .index-row {
            .logo {
                margin-top: 50px;
            }
        }
    }
}
@media screen and (max-width: 768px) {
    .index {
        height: auto;
        padding: 50px 0;
        background: url($cdnPrefix+"/imgs/bgphone-top-p20n.jpg") center center
            no-repeat;
        background-size: 100%;
        .index-row {
            .logo {
                width: 500px;
                margin-top: 20px;
            }
            .slogan {
                width: 600px;
            }
            .channel {
                margin-top: 50px;
                width: 600px;
                height: 100px;
                padding: 0 10%;
                .text {
                    font-size: 1rem;
                }
            }
            .poetry {
                display: none;
            }
        }
    }
}
@media screen and (max-width: 414px) {
    .index {
        height: auto;
        padding: 30px 0;
        .index-row {
            .logo {
                width: 200px;
            }
            .slogan {
                width: 300px;
            }
            .channel {
                margin-top: 50px;
                width: 350px;
                height: 60px;
                padding: 0 30px;
                .text {
                    font-size: 12px;
                    width: 120px;
                }
                .btn-down-group {
                    width: 150px;
                    display: flex;
                    justify-content: space-around;
                    a {
                        width: 45%;
                        display: flex;
                        align-items: center;
                        img {
                            width: 100%;
                        }
                    }
                }
            }
            .poetry {
                display: none;
            }
        }
    }
}
@media screen and (max-width: 375px) {
    .index {
        padding: 20px 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue